<template>
    <div>
        <div class="p-grid">
            <div class="p-col-12">
                <div class="card">
                    <div>
                        <Toolbar>
                            <template #left>
                                <Link href="/users/create"><Button label="Tambah User" icon="pi pi-plus" class="mr-2" />
                                </Link>
                            </template>
                        </Toolbar>
                    </div>
                </div>
            </div>
            <div class="p-col-12">
                <div class="card">
                    <DataTable ref="dt" :value="datatable.data" :lazy="true" data-key="id" :paginator="true" :rows="10"
                        :loading="datatable.loading" :total-records="datatable.totalRecords" filter-display="menu"
                        :global-filter-fields="datatable.globalFilterFields" v-model:filters="datatable.filters"
                        paginator-template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        :rows-per-page-options="[5, 10, 25]"
                        current-page-report-template="Menampilkan data ke {first} sampai {last} dari total {totalRecords} data"
                        @page="onPage($event)" @sort="onSort($event)" @filter="onFilter()">
                        <template #header>
                            <div class="table-header">
                                <h5 class="p-m-0 text-center">
                                    Daftar User
                                </h5>
                                <div class="flex justify-content-between">
                                    <Button type="button" icon="pi pi-filter-slash" label="Clear"
                                        class="p-button-outlined" @click="clearFilter()" />
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search" />
                                        <InputText v-model="datatable.filters['global'].value"
                                            @keydown.enter="onFilter()" placeholder="Keyword Search" />
                                    </span>
                                </div>
                            </div>
                        </template>
                        <Column field="id" header="ID" :sortable="false">
                            <template #body="slotProps">
                                {{ slotProps.data.number }}
                            </template>
                        </Column>
                        <Column field="name" header="Fullname" :sortable="true">
                            <template #body="slotProps">
                                {{ slotProps.data.fullname }}
                            </template>
                        </Column>
                        <Column field="email" header="E-mail" :sortable="true">
                            <template #body="slotProps">
                                {{ slotProps.data.email }}
                            </template>
                        </Column>
                        <Column field="roles" header="Roles" :sortable="true">
                            <template #body="slotProps">
                                <div v-if="slotProps.data.roles.length == 0">
                                    <span class="p-badge p-badge-danger">
                                        Belum punya role
                                    </span>
                                </div>
                                <div v-else>
                                    <span v-for="(role, idx_role) in slotProps.data.roles" :key="idx_role"
                                        class="p-badge p-badge-success">
                                        {{ role }}
                                    </span>
                                </div>
                            </template>
                        </Column>
                        <!-- <Column field="permission" header="Additional Permission" :sortable="false">
                            <template #body="slotProps">
                                <div v-if="slotProps.data.permissions.length == 0">
                                    <span class="p-badge p-badge-danger">
                                        Belum punya permission
                                    </span>
                                </div>
                                <div v-else>
                                    <span v-for="(permission,idx_permission) in slotProps.data.permissions" :key="idx_permission" class="p-badge p-badge-info">
                                        {{ permission}}
                                    </span>
                                </div>
                            </template>
                        </Column> -->
                        <Column header="Aksi" style="width: 150px;">
                            <template #body="slotProps">
                                <Button icon="pi pi-pencil" class="p-button-info p-button-sm mr-1"
                                    @click="edit(slotProps.data.id)" v-if="slotProps.data.can.update" />
                                <Button icon="pi pi-trash" class="p-button-sm p-button-danger"
                                    v-if="slotProps.data.can.delete" @click="showDeleteDialog(slotProps.data)" />
                            </template>
                        </Column>
                        <template #empty>
                            Belum ada Data!
                        </template>
                    </DataTable>
                </div>
            </div>
        </div>

        <DeleteDialog ref="deleteDialog" v-model:visible="deleteDialog" :loading="deletingModel" @delete="onDelete" />
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import { FilterMatchMode } from "primevue/api";
import DatatableService from "../../Services/DatatableService";
import Menubar from "primevue/menubar";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import DeleteDialog from "../../Components/DeleteDialog";
import Toolbar from "primevue/toolbar";
import { Link } from '@inertiajs/inertia-vue3';

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        DataTable,
        Column,
        Button,
        DeleteDialog,
        Toolbar,
        Link,
        InputText
    },
    data() {
        return {
            datatable: {
                loading: true,
                totalRecords: 0,
                data: null,
                globalFilterFields: ['fullname', 'email'],
                filters: {
                    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                    'status': { value: null, matchMode: FilterMatchMode.EQUALS },
                },
                lazyParams: {}
            },
            menuItems: [
                {
                    label: 'Tambah User',
                    icon: 'pi pi-fw pi-plus',
                    class: 'p-button-primary p-button-raised',
                    command: () => {
                        this.$inertia.get(this.route('users.create'));
                    },
                },
            ],
            importDialog: false,
            importForm: this.$inertia.form({
                file: null
            }),
            selectedModel: null,
            deleteDialog: false,
            deletingModel: false,
        }
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
    },
    mounted() {
        this.datatable.loading = true;
        this.datatable.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: 'id',
            sortOrder: -1,
            filters: this.datatable.filters,
            globalFilterFields: this.datatable.globalFilterFields
        };
        this.loadLazyData();
    },
    methods: {
        loadLazyData() {
            this.datatable.loading = true;
            this.datatableService.getData(this.route('users.datatable'), this.datatable.lazyParams).then(data => {
                this.datatable.data = data.data;
                this.datatable.totalRecords = data.total;
                this.datatable.loading = false;
            });
        },
        onFilter() {
            this.datatable.lazyParams.filters = this.datatable.filters;
            console.log('huehue');
            this.loadLazyData();
        },
        clearFilter() {
            this.datatable.filters =
            {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'status': { value: null, matchMode: FilterMatchMode.EQUALS },
            };

            this.datatable.lazyParams.filters = this.datatable.filters;
            this.loadLazyData();
        },
        onPage(event) {

            this.datatable.lazyParams = {
                globalFilterFields: this.datatable.lazyParams.globalFilterFields,
                ...event
            };
            console.log(this.datatable.lazyParams);
            this.loadLazyData();
        },
        onSort(event) {
            this.datatable.lazyParams = {
                globalFilterFields: this.datatable.lazyParams.globalFilterFields,
                ...event
            };
            this.loadLazyData();
        },
        edit(id) {
            this.$inertia.visit(this.route('users.edit', id), { preserveScroll: true });
        },
        showDeleteDialog(model) {
            this.selectedModel = model;
            this.deleteDialog = true;
        },
        onDelete() {
            this.deletingModel = true;
            this.$inertia.delete(this.route('users.destroy', this.selectedModel.id), {
                onSuccess: () => {
                    this.deletingModel = false;
                    this.deleteDialog = false;
                    this.loadLazyData();
                    this.$refs.deleteDialog.onClose();
                }
            })
        },
    }
}
</script>

<style scoped></style>
